import { render, staticRenderFns } from "./CardProductsCart.vue?vue&type=template&id=24ef1f76"
import script from "./CardProductsCart.vue?vue&type=script&setup=true&lang=js"
export * from "./CardProductsCart.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports